export const DEFAULT_BASE_URL = "https://api.liveblocks.io";
